<div class="wl-list-builder-container">
  <div class="row hidden-xs">
    <div class="col-sm-5">
      <h4>
        {{ availableValuesHeader }}
      </h4>
    </div>

    <div class="col-sm-offset-2 col-sm-5">
      <h4>
        {{ selectedValuesHeader }}
      </h4>
    </div>
  </div>

  <div class="form-group">
    <div class="col-sm-5">
      <h4 class="hidden-sm hidden-md hidden-lg">
        {{ availableValuesHeader }}
        {{ availableItems.length }}
      </h4>
      <div class="wl-list-builder-selector-box">
        <ul class="list-unstyled">
          <li
            *ngFor="let item of availableItems"
            class="wl-list-builder-selector-code"
            [class.bg-primary]="item.Selected"
            (click)="item.Selected = !item.Selected"
          >
            {{ item.DisplayText }}
          </li>
        </ul>
      </div>
    </div>

    <div class="col-sm-2">
      <p class="hidden-xs text-center">
        <button pButton type="button" class="atlas-btn atlas-btn-default" icon="pi pi-chevron-right" (click)="assignSelectedItems()"></button>
      </p>

      <p class="hidden-xs text-center">
        <button pButton type="button" class="atlas-btn atlas-btn-default" icon="pi pi-chevron-left" (click)="unassignSelectedItems()"></button>
      </p>

      <p class="wl-list-builder-selector-button-mobile hidden-sm hidden-md hidden-lg">
        <button pButton type="button" class="atlas-btn atlas-btn-default" icon="pi pi-chevron-down" (click)="assignSelectedItems()"></button>

        <button pButton type="button" class="atlas-btn atlas-btn-default" icon="pi pi-chevron-up" (click)="unassignSelectedItems()"></button>
      </p>
    </div>

    <div class="col-sm-5">
      <h4 class="hidden-sm hidden-md hidden-lg">
        {{ selectedValuesHeader }}
      </h4>
      <div class="wl-list-builder-selector-box">
        <ul class="list-unstyled">
          <li
            *ngFor="let item of assignedItems"
            class="wl-list-builder-selector-code"
            [class.bg-primary]="item.Selected"
            (click)="toggleItemSelected(item)"
          >
            {{ item.DisplayText }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
